

        // =======================================================================
        // Admin panel (platform admin only — Obsidian Arc)
        // =======================================================================
        // USD -> GBP conversion. Storage stays in USD (matches vendor billing).
        // Update this constant when the rate drifts noticeably (currently ~0.744 May 2026).
        const USD_TO_GBP = 0.744;

export { USD_TO_GBP };
